import React from "react";

import styled from "@emotion/styled";

import resolveWebView from "../../../../../utils/webViewRedirect";
import { Column, columnCss, Columns } from "../../../../shared/BulmaGrid";
import { navigate } from "../../../../shared/LinkComponent";
import Button from "../../../../shared/NewForms/Button";
import Section from "../../../../shared/Section";
import TextAlign from "../../../../shared/TextAlign";
import useStepDeliveryAddress from "../StepDeliveryAddress/store";
import useStepDeliveryDetailsStore from "../StepDeliveryDetails/store";
import useAgbStore from "../StepOverview/Agb/store";
import useStepOverviewType from "../StepOverview/store";
import useStepPaymentType from "../StepPaymentType/store";
import useStepProductChoieStore from "../StepProductChoice/store";
import useStepButtonsStore from "./store";

const FinalWrapper = styled.div`
    text-align: center;
`;

const TextAlignColumn = styled(TextAlign)`
    ${columnCss()}
`;

const StepButtons = () => {
    const [
        editMode,
        currentStepIndex,
        previousStepVisible,
        nextStep,
        previousStep,
        setEditMode,
        setStepButtonAction,
    ] = useStepButtonsStore((state) => [
        state.editMode,
        state.currentStepIndex,
        state.previousStepVisible,
        state.nextStep,
        state.previousStep,
        state.setEditMode,
        state.setStepButtonAction,
    ]);

    const [produktStepIsValid] = useStepProductChoieStore((state) => [
        state.produktStepIsValid,
    ]);

    const [lieferdetailsStepIsValid] = useStepDeliveryDetailsStore((state) => [
        state.lieferdetailsStepIsValid,
    ]);

    const [deliveryAddressStepIsValid] = useStepDeliveryAddress((state) => [
        state.deliveryAddressStepIsValid,
    ]);

    const [zahlartStepIsValid] = useStepPaymentType((state) => [
        state.zahlartStepIsValid,
    ]);

    const [isAgbValid] = useAgbStore((state) => [state.isAgbValid]);

    const [uebersichtStepIsValid, checkoutIsExpired] = useStepOverviewType(
        (state) => [state.uebersichtStepIsValid, state.checkoutIsExpired]
    );

    const next = () => {
        setStepButtonAction("next");
        if (editMode) {
            setEditMode(false);
            void navigate(resolveWebView("/heizoel/bestellung/uebersicht"));
        } else {
            nextStep(
                produktStepIsValid,
                lieferdetailsStepIsValid,
                deliveryAddressStepIsValid,
                zahlartStepIsValid,
                isAgbValid,
                uebersichtStepIsValid
            );
        }
    };

    const previous = () => {
        setStepButtonAction("previous");
        if (editMode) {
            setEditMode(false);
            void navigate(resolveWebView("/heizoel/bestellung/uebersicht"));
        } else {
            previousStep();
        }
    };

    return (
        <Section withMargin>
            {currentStepIndex < 4 ? (
                <Columns>
                    <Column>
                        {previousStepVisible() && (
                            <Button
                                color="blueOutline"
                                onClick={previous}
                                data-gtag="hel:checkout:previous"
                            >
                                Zurück
                            </Button>
                        )}
                    </Column>
                    <TextAlignColumn align="right">
                        <Button onClick={next} data-gtag="hel:checkout:next">
                            {editMode ? "Speichern" : "Weiter"}
                        </Button>
                    </TextAlignColumn>
                </Columns>
            ) : (
                <>
                    {!checkoutIsExpired && (
                        <FinalWrapper>
                            <Button onClick={next}>
                                Kostenpflichtig bestellen
                            </Button>
                        </FinalWrapper>
                    )}
                </>
            )}
        </Section>
    );
};

export default StepButtons;
